import Enums from "../enums/enums";
import i18n from "../locales/i18n";
function setNumber(x) {
  return x.ToNumber();
}
function setNumberDecimals(x, decimal = 2) {
  return x.FormatMoney(decimal);
}
function ChangeFormType(formType) {
  switch (formType) {
    case Enums.ChangeFormType.None:
      return "";
      break;
    case Enums.ChangeFormType.DayOnDay:
      return "DoD";
      break;
    case Enums.ChangeFormType.WeakOnWeak:
      return "WoW";
      break;
    case Enums.ChangeFormType.MonthOnMonth:
      return "MoM";
      break;
    case Enums.ChangeFormType.QuarterOnQuarter:
      return "QoQ";
      break;
    case Enums.ChangeFormType.YearOnYear:
      return "YoY";
      break;
  }
}
function GetPercentChangeValue(value, formType) {
  let changeValue = "";
  if (formType != Enums.ChangeFormType.None) {
    if (value !== null) {
      if (value > 999.99) {
        value = `+ ${i18n.t("exceed")} 999.99`;
      } else if (value < -999.99) {
        value = `- ${i18n.t("exceed")} 999.99`;
      } else if (value > 0) {
        value = "+" + value.FormatMoney();
      } else {
        value = value.FormatMoney();
      }
      changeValue = `${value}% ${ChangeFormType(formType)}`;
    } else {
      changeValue = `N/A ${ChangeFormType(formType)}`;
    }
  }
  return changeValue;
}

function setDateFormat(date) {
  let start = new Date(date);
  let day = start.getDate().toString();
  let month = (parseInt(start.getMonth(), 10) + 1).toString();
  let year = start.getFullYear();

  day = day.length == 2 ? day : "0" + day;
  month = month.length == 2 ? month : "0" + month;

  let dateFormat = day + "/" + month + "/" + year;
  let minDate = new Date(null);

  if (date == null || +date == +minDate || isNaN(day) || isNaN(month) || isNaN(year)) {
    return "-";
  } else {
    return dateFormat;
  }
}

function GetMonthName(index, language = "th") {
  let monthListTh = [
    { fullName: "มกราคม", name: "ม.ค." },
    { fullName: "กุมภาพันธ์", name: "ก.พ." },
    { fullName: "มีนาคม", name: "มี.ค." },
    { fullName: "เมษายน", name: "เม.ย." },
    { fullName: "พฤษภาคม", name: "พ.ค." },
    { fullName: "มิถุนายน", name: "มิ.ย." },
    { fullName: "กรกฎาคม", name: "ก.ค." },
    { fullName: "สิงหาคม", name: "ส.ค." },
    { fullName: "กันยายน", name: "ก.ย." },
    { fullName: "ตุลาคม", name: "ต.ค." },
    { fullName: "พฤศจิกายน", name: "พ.ย." },
    { fullName: "ธันวาคม", name: "ธ.ค." },
  ];

  let monthListEn = [
    { fullName: "January", name: "Jan" },
    { fullName: "February", name: "Feb" },
    { fullName: "March", name: "Mar" },
    { fullName: "April", name: "Apr" },
    { fullName: "May", name: "May" },
    { fullName: "June", name: "Jun" },
    { fullName: "July", name: "July" },
    { fullName: "August", name: "Aug" },
    { fullName: "September", name: "Sep" },
    { fullName: "October", name: "Oct" },
    { fullName: "November", name: "Nov" },
    { fullName: "December", name: "Dec" },
  ];

  if (index == "all") {
    if (language == "th") {
      return monthListTh;
    } else {
      return monthListEn;
    }
  } else {
    if (language == "th") {
      return monthListTh[index];
    } else {
      return monthListEn[index];
    }
  }
}

export { setNumberDecimals, setNumber, ChangeFormType, GetPercentChangeValue, setDateFormat, GetMonthName };
